"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DbGraphSchema = exports.TapeBuilderNodeGraphSchema = exports.isTapeBuilderNodeType = void 0;
const zod_1 = require("zod");
const finley_types_1 = require("@finley-technologies/finley-types");
const tape_builder_1 = require("./types/tape-builder");
const registry_1 = require("./uiNodes/registry");
const isTapeBuilderNodeType = (value) => registry_1.uiNodes.some((node) => node.nodeType === value);
exports.isTapeBuilderNodeType = isTapeBuilderNodeType;
/**
 * Structure only: node types are checked, but each node's configuration is
 * validated by the converter (tapeBuilderGraphToArtifactsDocument), which
 * reports every invalid node rather than the first.
 */
exports.TapeBuilderNodeGraphSchema = zod_1.z.object({
    nodes: zod_1.z.array(zod_1.z.object({
        metadata: zod_1.z.object({
            tapeBuilderNodeId: zod_1.z.string(),
            tapeBuilderNodeType: zod_1.z.custom(exports.isTapeBuilderNodeType, { message: 'unknown tapeBuilderNodeType' }),
        }),
        configuration: zod_1.z.looseObject({}),
    })),
    edges: zod_1.z.array(zod_1.z.object({ source: zod_1.z.string(), target: zod_1.z.string() })),
});
/** A persisted graph: every artifact is validated against its node's schema. */
exports.DbGraphSchema = zod_1.z.object({
    artifacts: zod_1.z.array(tape_builder_1.TapeBuilderRecordDBSchema),
    dependencies: zod_1.z.array(finley_types_1.DbTable.ArtifactDependencyRecordSchema),
});
//# sourceMappingURL=graphSchemas.js.map